import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface UserListLastConnectionHeaderProps
  extends HeaderContext<GatewayUserModel, GatewayUserModel['lastConnection']> {}

export const UserListLastConnectionHeader =
  (): // props: UserListLastConnectionHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-user.last-connection');
  };
